import PostCreator from "./PostCreator"

export default PostCreator
